module.exports = __webpack_public_path__ + "static/media/Whitney-Book.7234adf2.otf";